import { LessonInfo } from '@openeducation/react-native-lesson-player';
import { useEffect } from 'react';

import { LessonEvent } from '../enums/lesson-event';
import { postMessage } from '../utils/post-message';
import { useListenToMessage } from './useListenToMessage';

export const useLessonInfo = (onLessonInfo: (LessonInfo: LessonInfo) => void) => {
  useListenToMessage((event: { data: { type: LessonEvent; value: LessonInfo } }) => {
    if (!event) {
      return;
    }

    if (event.data?.type === LessonEvent.SEND_LESSON_INFO && onLessonInfo) {
      onLessonInfo(event.data.value);
    }
  });

  useEffect(() => {
    postMessage({ type: LessonEvent.REQUEST_LESSON_INFO });
  }, []);
};
